(() => {
  // Calendar arithmetic at local noon avoids daylight-saving boundary issues.
  function addDays(date, days) {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
    result.setDate(result.getDate() + days);
    return result;
  }

  function update() {
    const today = new Date();
    const shipping = addDays(today, 1);
    const earliest = addDays(today, 3);
    const latest = addDays(today, 7);
    const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN', {
      day: 'numeric', month: 'short',
      ...(latest.getFullYear() !== today.getFullYear() ? { year: 'numeric' } : {}),
    });
    document.querySelectorAll('[data-delivery-estimate]').forEach(element => {
      element.querySelector('[data-delivery-today]').textContent = format.format(today);
      element.querySelector('[data-delivery-shipping]').textContent = format.format(shipping);
      element.querySelector('[data-delivery-arrival]').textContent =
        `${format.format(earliest)} – ${format.format(latest)}`;
    });
  }

  update();
  document.addEventListener('shopify:section:load', update);
  // Refresh a page revisited on another day without running a polling timer.
  window.addEventListener('pageshow', update);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update();
  });
})();
